<script setup>
import { defineProps, provide } from 'vue';
import CardLote from './CardLote';

const props = defineProps({
    leilao: Object,
    lotes: Array,
    onLoteClick: Function,
});

// Fornecer callback para componentes filhos
if (props.onLoteClick) {
    provide('onLoteClick', props.onLoteClick);
}

</script>

<template>
    <div class="flex row full-width q-pa-sm">
        <card-lote :key="lote.id" v-for="lote in lotes" :lote-init="lote" :leilao-init="leilao" />
    </div>
</template>
